import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

export const api = {
    getProjects: () => client.get("/projects").then((r) => r.data),
    getNews: () => client.get("/news").then((r) => r.data),
    getStats: () => client.get("/stats").then((r) => r.data),
    sendContact: (payload) => client.post("/contact", payload).then((r) => r.data),
    subscribeNewsletter: (payload) => client.post("/newsletter", payload).then((r) => r.data),
    submitMembership: (payload) => client.post("/membership", payload).then((r) => r.data),
    submitDonation: (payload) => client.post("/donations", payload).then((r) => r.data),
};

export default api;
